<h2 mat-dialog-title>Create Buy Contract</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="contract-form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Name (optional)</mat-label>
      <input matInput type="text" formControlName="name" placeholder="Enter contract name">
      <mat-error>{{ getErrorMessage('name') }}</mat-error>
    </mat-form-field>

    <div class="content-row">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Target Coins (K)</mat-label>
        <input matInput type="number" formControlName="target_coins" placeholder="e.g. 100">
        <mat-icon matPrefix>monetization_on</mat-icon>
        <mat-error>{{ getErrorMessage('target_coins') }}</mat-error>
      </mat-form-field>

      <div class="toggle-row">
        <mat-button-toggle-group formControlName="target_type" aria-label="Target Type">
          <mat-button-toggle value="sent">Sent</mat-button-toggle>
          <mat-button-toggle value="received">Received</mat-button-toggle>
        </mat-button-toggle-group>
        <span class="toggle-label">Calculate coins with: </span>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Note (optional)</mat-label>
      <textarea matInput formControlName="note" placeholder="Enter a note" rows="1"></textarea>
      <mat-icon matPrefix>notes</mat-icon>
    </mat-form-field>

    @if (isAdmin) {
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Fee (optional)</mat-label>
      <input matInput type="number" formControlName="fee" placeholder="0">
      <mat-icon matPrefix>percent</mat-icon>
      <mat-error>{{ getErrorMessage('fee') }}</mat-error>
    </mat-form-field>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="loading || form.invalid">
    @if (loading) {
    <mat-spinner diameter="20"></mat-spinner>
    } @else {
    Create Contract
    }
  </button>
</mat-dialog-actions>
